import React from "react";

export const Reveal = ({ children, className = "" }) =>
  className ? <div className={className}>{children}</div> : <>{children}</>;
